import { useState, useEffect, useContext } from "react";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import { DataContext } from "../../../context/DataContext";
import TableLoad from "../../componentsTools/TableLoad";
import Table from "../../componentsTable/TableClient";
import ChartLine from "../../componentsTools/ChartLine";

export default function Reports() {
  const { session, idEmpresa, user } = useContext(DataContext);
  const [fechas, setFechas] = useState({ fInicio: "", fFin: "" });
  const [load, setLoad] = useState(true);

  const [ventasComprasMoneda, setVentasComprasMoneda] = useState([]);
  const [ventasDiaSemanaMes, setVentasDiaSemanaMes] = useState([]);
  const [comprasDiaSemanaMes, setComprasDiaSemanaMes] = useState([]);
  const [ventasComprasMonedaUser, setVentasComprasMonedaUser] = useState([]);
  const [ventasDiaSemanaMesUser, setVentasDiaSemanaMesUser] = useState([]);

  const [expandedSections, setExpandedSections] = useState({
    ventas: false,
    compras: false,
    usuarios: false,
  });

  const [chartView, setChartView] = useState({
    ventas: "diario",
    compras: "diario",
    usuario: "diario",
  });

  const columns = [
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="name"
          style={{ width: "10%" }}
        >
          Moneda
        </th>
      ),
      accessorKey: "moneda",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.moneda}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="company"
          style={{ width: "15%" }}
        >
          <div className="d-inline-flex flex-center">
            <div
              className="d-flex align-items-center px-1 py-1 bg-primary-subtle rounded me-2"
              style={{ width: "27px" }}
            >
              <span
                className="text-primary-dark"
                data-feather="shopping-bag"
              ></span>
            </div>
            <span>Total ventas</span>
          </div>
        </th>
      ),
      accessorKey: "totalVentas",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.totalVentas}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-end border-translucent"
          scope="col"
          data-sort="company"
          style={{ width: "15%" }}
        >
          <div className="d-inline-flex flex-center">
            <div
              className="d-flex align-items-center px-1 py-1 bg-primary-subtle rounded me-2"
              style={{ width: "27px" }}
            >
              <span
                className="text-primary-dark"
                data-feather="shopping-cart"
              ></span>
            </div>
            <span>Total compras </span>
          </div>
        </th>
      ),
      accessorKey: "totalCompras",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-end border-translucent">
          {row.original.totalCompras}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle ps-3 pe-5 text-uppercase border-translucent"
          scope="col"
          data-sort="company"
          style={{ width: "15%" }}
        >
          <div className="d-inline-flex flex-center">
            <span>Total</span>
          </div>
        </th>
      ),
      accessorKey: "diferencia",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap fw-semibold ps-3 border-translucent">
          {row.original.diferencia}
        </td>
      ),
    },
  ];

  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formatDate = (date) => date.toISOString().split("T")[0];

    const fechasIniciales = {
      fInicio: formatDate(firstDay),
      fFin: formatDate(lastDay),
    };

    setFechas(fechasIniciales);
    LoadGeneral(fechasIniciales);
  }, []);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFechas((prevFechas) => ({
      ...prevFechas,
      [name]: value,
    }));
  };

  const LoadGeneral = async ({ fInicio, fFin }) => {
    if (!fInicio || !fFin) return;
    setLoad(true);

    try {
      const [
        resVentasComprasMoneda,
        resVentasDiaSemanaMes,
        resComprasDiaSemanaMes,
        resVentasComprasMonedaUser,
        resVentasDiaSemanaMesUser,
      ] = await Promise.allSettled([
        petitions.getGetReporteVentasComprasMoneda(
          idEmpresa(),
          session().token,
          fInicio,
          fFin
        ),
        petitions.getReporteVentasDiaSemanaMes(
          idEmpresa(),
          session().token,
          fInicio,
          fFin
        ),
        petitions.getGetReporteComprasDiaSemanaMes(
          idEmpresa(),
          session().token,
          fInicio,
          fFin
        ),
        petitions.getGetReporteVentasComprasMonedaUser(
          idEmpresa(),
          session().token,
          fInicio,
          fFin,
          user?.idUsuario || ""
        ),
        petitions.getGetReporteVentasDiaSemanaMesUser(
          idEmpresa(),
          session().token,
          fInicio,
          fFin,
          user?.idUsuario || ""
        ),
      ]);

      const handleResponse = (res, setter, label) => {
        if (res.status === "fulfilled") {
          const data = res.value;
          if (data?.status === "success") {
            setter(data.data);
          } else {
            toast.error(data?.message || `Error al cargar ${label}`);
          }
        } else {
          toast.error(`Error en la solicitud de ${label}`);
        }
      };

      handleResponse(
        resVentasComprasMoneda,
        setVentasComprasMoneda,
        "ventas/compras por moneda"
      );
      handleResponse(
        resVentasDiaSemanaMes,
        setVentasDiaSemanaMes,
        "ventas día/semana/mes"
      );
      handleResponse(
        resComprasDiaSemanaMes,
        setComprasDiaSemanaMes,
        "compras día/semana/mes"
      );
      handleResponse(
        resVentasComprasMonedaUser,
        setVentasComprasMonedaUser,
        "ventas/compras por moneda (usuario)"
      );
      handleResponse(
        resVentasDiaSemanaMesUser,
        setVentasDiaSemanaMesUser,
        "ventas día/semana/mes (usuario)"
      );

      const allRejected = [
        resVentasComprasMoneda,
        resVentasDiaSemanaMes,
        resComprasDiaSemanaMes,
        resVentasComprasMonedaUser,
        resVentasDiaSemanaMesUser,
      ].every((r) => r.status === "rejected" || r.value?.status === "error");

      if (allRejected) {
        toast.error("No se pudieron cargar los reportes. Intenta nuevamente.");
      }
    } catch (error) {
      toast.error("Error inesperado al cargar los reportes.");
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="container-fluid">
      {/* Header con controles de fecha y resumen */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-6 gap-3">
            <h2 className="mb-0 text-body-emphasis">Reportes</h2>
            <div className="d-flex flex-column flex-sm-row gap-3 w-100 w-lg-auto">
              <div className="d-flex align-items-center gap-2">
                <label className="form-label mb-0" htmlFor="datepickerDesde">
                  Desde:
                </label>
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="datepickerDesde"
                  type="date"
                  name="fInicio"
                  value={fechas.fInicio}
                  onChange={handleDateChange}
                />
              </div>
              <div className="d-flex align-items-center gap-2">
                <label className="form-label mb-0" htmlFor="datepickerHasta">
                  Hasta:
                </label>
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="datepickerHasta"
                  type="date"
                  name="fFin"
                  value={fechas.fFin}
                  onChange={handleDateChange}
                />
              </div>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn px-3 btn-phoenix-secondary rounded-4"
                  type="button"
                  onClick={() => {
                    LoadGeneral(fechas);
                  }}
                >
                  <span
                    className="fa-solid fa-filter text-primary"
                    data-fa-transform="down-3"
                  ></span>
                </button>
              </div>
            </div>
          </div>

          {/* Resumen de totales */}
          <div className="row g-3 mb-4">
            <div className="col-md-12">
              {load ? (
                <TableLoad />
              ) : (
                <Table
                  data={ventasComprasMoneda}
                  columns={columns}
                  classNameTable="table fs-9 mb-0 leads-table border-top border-translucent"
                  classNameTrHead=""
                  classNameTrBody="hover-actions-trigger btn-reveal-trigger position-static"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Sección de Ventas */}
      <div className="row mb-3">
        {/* 🔹 Tarjeta única de Ventas */}
        <div className="col-12 col-lg-4 mb-3 mb-lg-0">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body text-center py-3">
              {/* 🔹 Header */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0 fw-bold">Ventas</h4>
                <button
                  className="btn px-3 btn-subtle-secondary rounded-circle"
                  onClick={() =>
                    setExpandedSections((prev) => ({
                      ...prev,
                      ventas: !prev.ventas,
                    }))
                  }
                >
                  <i
                    className={`fas ${
                      expandedSections.ventas ? "fa-minus" : "fa-plus"
                    }`}
                  ></i>
                </button>
              </div>

              {/* 🔹 Total ventas en soles */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-body-tertiary">Total ventas</span>
                <span className="fw-bold">
                  S/{" "}
                  {ventasComprasMoneda
                    ?.find((item) => item.moneda?.toUpperCase() === "SOLES")
                    ?.totalVentas?.toLocaleString("es-PE", {
                      minimumFractionDigits: 2,
                    }) ?? "0.00"}
                </span>
              </div>

              {/* 🔹 Detalle expandible por moneda */}
              {expandedSections.ventas && (
                <>
                  {ventasComprasMoneda?.map((item) => (
                    <div
                      key={item.moneda}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span className="text-body-tertiary">{item.moneda}</span>
                      <span className="fw-bold">
                        {item.simbolo}{" "}
                        {item.totalVentas?.toLocaleString("es-PE", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-8">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">              
              {/* Controles de filtro */}
              <div className="d-flex justify-content-center justify-content-lg-end mb-5">
                <div
                  className="btn-group"
                  role="group"
                  data-gantt-scale="data-gantt-scale"
                >
                  {/* Día */}
                  <input
                    className="btn-check"
                    id="ventasDayView"
                    type="radio"
                    name="ventasScaleView"
                    value="diario"
                    checked={chartView.ventas === "diario"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, ventas: "diario" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.ventas === "diario" ? "active" : ""
                    }`}
                    htmlFor="ventasDayView"
                  >
                    Día
                  </label>

                  {/* Semana */}
                  <input
                    className="btn-check"
                    id="ventasWeekView"
                    type="radio"
                    name="ventasScaleView"
                    value="semanal"
                    checked={chartView.ventas === "semanal"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, ventas: "semanal" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.ventas === "semanal" ? "active" : ""
                    }`}
                    htmlFor="ventasWeekView"
                  >
                    Semana
                  </label>

                  {/* Mes */}
                  <input
                    className="btn-check"
                    id="ventasMonthView"
                    type="radio"
                    name="ventasScaleView"
                    value="mensual"
                    checked={chartView.ventas === "mensual"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, ventas: "mensual" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.ventas === "mensual" ? "active" : ""
                    }`}
                    htmlFor="ventasMonthView"
                  >
                    Mes
                  </label>
                </div>
              </div>
              
              {/* Área para gráfico de ECharts */}
              <div
                id="ventas-chart"
                className="d-flex align-items-center justify-content-center"
                style={{ height: "250px", width: "100%" }}
              >
                {ventasDiaSemanaMes &&
                Object.keys(ventasDiaSemanaMes).length > 0 ? (
                  <ChartLine
                    theme="light"
                    data={ventasDiaSemanaMes}
                    view={chartView.ventas}
                    type="ventas"
                  />
                ) : (
                  <span className="text-body-tertiary">
                    No hay datos disponibles
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección de Compras */}
      <div className="row mb-3">
        <div className="col-12 col-lg-4 mb-3 mb-lg-0">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body text-center py-3">
              {/* 🔹 Header */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0 fw-bold">Compras</h4>
                <button
                  className="btn px-3 btn-subtle-secondary rounded-circle"
                  onClick={() =>
                    setExpandedSections((prev) => ({
                      ...prev,
                      compras: !prev.compras,
                    }))
                  }
                >
                  <i
                    className={`fas ${
                      expandedSections.compras ? "fa-minus" : "fa-plus"
                    }`}
                  ></i>
                </button>
              </div>

              {/* 🔹 Total compras en soles */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-body-tertiary">Total compras</span>
                <span className="fw-bold">
                  S/{" "}
                  {ventasComprasMoneda
                    ?.find((item) => item.moneda?.toUpperCase() === "SOLES")
                    ?.totalCompras?.toLocaleString("es-PE", {
                      minimumFractionDigits: 2,
                    }) ?? "0.00"}
                </span>
              </div>

              {/* 🔹 Detalle expandible por moneda */}
              {expandedSections.compras && (
                <>
                  {ventasComprasMoneda?.map((item) => (
                    <div
                      key={item.moneda}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span className="text-body-tertiary">{item.moneda}</span>
                      <span className="fw-bold">
                        {item.simbolo}{" "}
                        {item.totalCompras?.toLocaleString("es-PE", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-8">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
              {/* Controles de filtro */}
              <div className="d-flex justify-content-center justify-content-lg-end mb-5">
                <div
                  className="btn-group"
                  role="group"
                  data-gantt-scale="data-gantt-scale"
                >
                  <input
                    className="btn-check"
                    id="comprasDayView"
                    type="radio"
                    name="comprasScaleView"
                    value="diario"
                    checked={chartView.compras === "diario"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, compras: "diario" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.compras === "diario" ? "active" : ""
                    }`}
                    htmlFor="comprasDayView"
                  >
                    Día
                  </label>

                  <input
                    className="btn-check"
                    id="comprasWeekView"
                    type="radio"
                    name="comprasScaleView"
                    value="semanal"
                    checked={chartView.compras === "semanal"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, compras: "semanal" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.compras === "semanal" ? "active" : ""
                    }`}
                    htmlFor="comprasWeekView"
                  >
                    Semana
                  </label>

                  <input
                    className="btn-check"
                    id="comprasMonthView"
                    type="radio"
                    name="comprasScaleView"
                    value="mensual"
                    checked={chartView.compras === "mensual"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, compras: "mensual" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.compras === "mensual" ? "active" : ""
                    }`}
                    htmlFor="comprasMonthView"
                  >
                    Mes
                  </label>
                </div>
              </div>

              {/* Área para gráfico de ECharts */}
              <div
                id="compras-chart"
                className="d-flex align-items-center justify-content-center"
                style={{ height: "250px", width: "100%" }}
              >
                {comprasDiaSemanaMes &&
                Object.keys(comprasDiaSemanaMes).length > 0 ? (
                  <ChartLine
                    theme="light"
                    data={comprasDiaSemanaMes}
                    view={chartView.compras}
                    type="compras"
                  />
                ) : (
                  <span className="text-body-tertiary">
                    No hay datos disponibles
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección de Usuarios */}
      <div className="row mb-3">
        <div className="col-12 col-lg-4 mb-3 mb-lg-0">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body text-center py-3">
              {/* 🔹 Header */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0 fw-bold">Usuarios</h4>
                <button
                  className="btn px-3 btn-subtle-secondary rounded-circle"
                  onClick={() =>
                    setExpandedSections((prev) => ({
                      ...prev,
                      usuarios: !prev.usuarios,
                    }))
                  }
                >
                  <i
                    className={`fas ${
                      expandedSections.usuarios ? "fa-minus" : "fa-plus"
                    }`}
                  ></i>
                </button>
              </div>

              {/* 🔹 Total ventas en soles */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-body-tertiary">
                  {user?.nombres || ""}
                </span>
                <span className="fw-bold">
                  S/{" "}
                  {ventasComprasMonedaUser
                    ?.find((item) => item.moneda?.toUpperCase() === "SOLES")
                    ?.totalVentas?.toLocaleString("es-PE", {
                      minimumFractionDigits: 2,
                    }) ?? "0.00"}
                </span>
              </div>

              {/* 🔹 Detalle expandible por moneda */}
              {expandedSections.usuarios && (
                <>
                  {ventasComprasMonedaUser?.map((item) => (
                    <div
                      key={item.moneda}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span className="text-body-tertiary">{item.moneda}</span>
                      <span className="fw-bold">
                        {item.simbolo}{" "}
                        {item.totalVentas?.toLocaleString("es-PE", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-8">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
              {/* Controles de filtro */}
              <div className="d-flex justify-content-center justify-content-lg-end mb-5">
                <div
                  className="btn-group"
                  role="group"
                  data-gantt-scale="data-gantt-scale"
                >
                  <input
                    className="btn-check"
                    id="usuarioDayView"
                    type="radio"
                    name="usuarioScaleView"
                    value="diario"
                    checked={chartView.usuario === "diario"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, usuario: "diario" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.usuario === "diario" ? "active" : ""
                    }`}
                    htmlFor="usuarioDayView"
                  >
                    Día
                  </label>

                  <input
                    className="btn-check"
                    id="usuarioWeekView"
                    type="radio"
                    name="usuarioScaleView"
                    value="semanal"
                    checked={chartView.usuario === "semanal"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, usuario: "semanal" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.usuario === "semanal" ? "active" : ""
                    }`}
                    htmlFor="usuarioWeekView"
                  >
                    Semana
                  </label>

                  <input
                    className="btn-check"
                    id="usuarioMonthView"
                    type="radio"
                    name="usuarioScaleView"
                    value="mensual"
                    checked={chartView.usuario === "mensual"}
                    onChange={() =>
                      setChartView((prev) => ({ ...prev, usuario: "mensual" }))
                    }
                  />
                  <label
                    className={`btn btn-phoenix-secondary bg-body-highlight-hover fs-10 py-1 mb-0 ${
                      chartView.usuario === "mensual" ? "active" : ""
                    }`}
                    htmlFor="usuarioMonthView"
                  >
                    Mes
                  </label>
                </div>
              </div>

              {/* Área para gráfico de ECharts */}
              <div
                id="usuarios-chart"
                className="d-flex align-items-center justify-content-center"
                style={{ height: "250px", width: "100%" }}
              >
                {ventasDiaSemanaMesUser &&
                Object.keys(ventasDiaSemanaMesUser).length > 0 ? (
                  <ChartLine
                    theme="light"
                    data={ventasDiaSemanaMesUser}
                    view={chartView.usuario}
                    type="ventas"
                  />
                ) : (
                  <span className="text-body-tertiary">
                    No hay datos disponibles
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
